import AppModel from '@/models/AppModel'

const isDebug = process.env.NODE_ENV !== 'production'

export default {
  apiSetStore: (bvModal, params, callback) => {
    return AppModel.post('log/common', bvModal, params, (res) => {
      if (isDebug) {
        console.log(res.data) // res.data から res に変更
      }

      AppModel.validateStatus(res.data) // res.data から res に変更

      return Promise.resolve(res.data) // res.data から res に変更
    }, null, callback)
  }
}
